import React from 'react';
import { IResultsProps } from './IResultsProps';

const Results: React.FC<IResultsProps> = ({ protein, carbs, fat, calories, resultsText, reset }) => {

   return (
      <>
         <div className='results-container'>
            <div className='results-result-container border'>
               <p className='results-result-value'>{protein}</p><p className='results-result-unit'>g</p>
               <p className='results-result-type'>Proteins</p>
            </div>
            <div className='results-result-container border'>
               <p className='results-result-value'>{carbs}</p><p className='results-result-unit'>g</p>
               <p className='results-result-type'>Carbohydrates</p>
            </div>
            <div className='results-result-container border'>
               <p className='results-result-value'>{fat}</p><p className='results-result-unit'>g</p>
               <p className='results-result-type'>Fats</p>
            </div>
            <div className='results-result-container border'>
               <p className='results-result-value'>{calories}</p>
               <p className='results-result-type'>Calories</p>
            </div>
            <button className='reset-button' type='button' onClick={reset}>Calculate Another</button>
         </div>
         <div className='results-result-text-container border'>
            {resultsText && resultsText !== '' ? <p className='results-result-text'>{resultsText}</p> : null}
         </div>
      </>
   );
};

export default Results;
